// Resolve a Firestore question's HTML for the active language (spec §6.2).
// `htmlTranslations` ({ de: '<p>…</p>', … }) is written by the phase-2
// auto-translation Cloud Function (or by hand until it exists); questions
// without a translation fall back to the base `html`.
//
// Display-only: edit flows must keep using the base `html` — a moderator
// editing a question edits the original, never a translation of it.
export function localizeQuestionHtml(question, language) {
  return question?.htmlTranslations?.[language] ?? question?.html;
}

export default localizeQuestionHtml;
